export { Kundendivision } from './lib/__generated__/globalTypes';
export { useNutzerEntfernenMutation, useNutzerMandant, useNutzerMandanten } from './lib/nutzer-mandanten';
export type { NutzerMandanten as MandantByRealmId } from './lib/nutzer-mandanten';
export { useNutzerPartnerbetreuerQuery, usePartner } from './lib/NutzerPartnerbetreuerQuery';
export { OneplatformApiProvider } from './lib/oneplatform-api-provider';
export { usePartnerWechselnMutation } from './lib/PartnerWechselnMutation';

